import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'
import Image, { ImageProps } from 'next/legacy/image'

type ChakraNextImageProps = Pick<BoxProps, 'css' | 'as' | 'h' | 'w'> &
  ImageProps & { boxClass?: string }

function ChakraNextImage(props: ChakraNextImageProps) {
  const { css, as, h, w, boxClass, ...imageProps } = props
  return (
    <Box css={css} as={as} h={h} w={w} className={boxClass}>
      <Image {...imageProps} unoptimized />
    </Box>
  )
}

export default ChakraNextImage
